import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/nettleworth-frontend/src/app/(charts)/calculators/retirement-fund-calculator/page.client.jsx");
